import React from "react";
import "./index.css";
import Sidebar from "../../../../components/Sidebar";
import TableHeader from "../../../../components/TableHeader/index";
import PageHeader from "../../../../components/PageHeader";
import Pagination from "../../../../components/Pagination";
import {checkPermission} from "../../../../utils/common";
import ModalCreateAdmissionsGroupUser from "./modalCreateAdmissionsGroupUser";
import ModalEditAdmissionsGroupUser from "./modalEditAdmissionsGroupUser";
import ModalDeleteAdmissionsGroupUser from "./modalDeleteAdmissionsGroupUser";
import CustomerGroupController from "../../../../services/qlts/admissions/customer-group-controller";

class AdmissionsGroupUserManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            listData: [],
            pageNumber: 0,
            pageSize: 20,
            sort: 'ASC',
            header: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "name",
                    name: "Tên nhóm",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "des",
                    name: "Mô tả",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "",
                    name: "Thao tác",
                    style: {minWidth: 120, textAlign: "center"},
                    sort: false
                }
            ]
        };
    }

    componentDidMount() {
        this.setState({showLoading: true},
            () => this.getListGroupCustomer()
        )
    }
    getListGroupCustomer() {
        let payload = {
            pageNumber: this.state.pageNumber,
            pageSize: 10,
            "sort": "created_at desc"
        };
        CustomerGroupController.getCustomerGroups(payload,res => {
            if (res.success) {
                let data = res.data.content;
                this.setState(
                    {
                        listData: res.data.content,
                        totalItem: res.data.totalElements,
                        totalPage: Math.round(res.data.totalElements / this.state.pageSize),
                        showLoading: data.length < 0
                    }
                );
            } else {
            }
        });
    }

    handleChangePage = page => {
        this.setState(
            {
                pageNumber: page
            },
            () => {
                this.getListGroupCustomer();
            }
        );
    };


    render() {
        let {listData, pageNumber, header} = this.state;
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="admissions-group-user" parentClass="admissions-management"/>
                        <div className="col-md-10 tab-content with-loading">
                            {this.state.showLoading &&
                            <div className="content-loading col-12 ml-3 align-items-center"
                                 style={{display: 'block'}}>
                                <div className="spinner-grow text-info"/>
                            </div>
                            }
                            <div className="card col-12">
                                <div className="pt-3 mb-2">
                                    <PageHeader routerEnable={true} title="Quản lý nhóm khách hàng"/>
                                </div>
                                <form className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-12 col-md-12 p-0 pr-md-3 d-flex"
                                             style={{
                                                 alignItems: "center",
                                                 justifyContent: "right"
                                             }}>
                                            {checkPermission("QLTS_CUSTOMER_GROUP_ADD") &&
                                                <button
                                                    style={{height: 35, marginRight: 12, marginBottom: 12}}
                                                    type="button"
                                                    className="border-1-s background-btn type-button-fix btn btn-primary btn-sm"
                                                    onClick={() => this.setState({showModalCreate: true})}
                                                >
                                                    Thêm mới
                                                </button>
                                            }
                                        </div>
                                    </div>
                                </form>
                                <div className="p-0 mb-3">
                                    <div className="table-wrapper">
                                        <table
                                            className="table table-striped table-data table-responsive table-bordered">
                                            <table className="table">
                                                <thead>
                                                <TableHeader
                                                    header={header}
                                                />
                                                </thead>
                                                {!this.state.listData ||
                                                this.state.listData.length == 0 ? (
                                                    <tbody>
                                                    <tr>
                                                        <td colSpan={12}>
                                                            <div className="text-center">
                                                                Không có dữ liệu
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                ) : (
                                                    <tbody>
                                                    {listData &&
                                                    listData.length > 0 &&
                                                    listData?.map((row, index) => (
                                                        <tr style={{height: 50}}>
                                                            <td style={{textAlign: "center"}} scope="row">
                                                                {" "}
                                                                {this.state.pageNumber * this.state.pageSize +
                                                                index +
                                                                1}
                                                            </td>

                                                            <td style={{textAlign: "left"}}>
                                                                {row.name}
                                                            </td>
                                                            <td style={{textAlign: "left"}}>
                                                                {row.description}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {checkPermission("QLTS_CUSTOMER_GROUP_EDIT") &&
                                                                    <button className="btn btn-action p-2"
                                                                            title='Sửa'
                                                                            style={{cursor: 'pointer'}}
                                                                            onClick={() => {
                                                                                this.setState({itemSelected: row.id, showModalEdit: true})
                                                                            }}
                                                                    >
                                                                        <i className="ti-pencil-alt"/>
                                                                    </button>
                                                                }
                                                                {checkPermission("QLTS_CUSTOMER_GROUP_DELETE") &&
                                                                    <button className="btn btn-action p-2"
                                                                            title='Xóa'
                                                                            style={{cursor: 'pointer'}}
                                                                            onClick={() => {
                                                                                this.setState({itemSelected: row.id, showModalDelete: true})
                                                                            }}
                                                                    >
                                                                        <i className="ti-trash"/>
                                                                    </button>
                                                                }
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    </tbody>
                                                )}
                                            </table>
                                        </table>
                                    </div>
                                    <div className="pagination-right">
                                        <Pagination
                                            activePage={this.state.pageNumber}
                                            itemsCountPerPage={this.state.pageSize}
                                            totalItemsCount={this.state.totalItem}
                                            changeHandler={page => this.handleChangePage(page)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ModalCreateAdmissionsGroupUser
                    show={this.state.showModalCreate}
                    onHide={() => this.setState({showModalCreate: false})}
                    onRefresh={() => this.getListGroupCustomer()}
                />
                <ModalEditAdmissionsGroupUser
                    show={this.state.showModalEdit}
                    onHide={() => this.setState({showModalEdit: false})}
                    onRefresh={() => this.getListGroupCustomer()}
                    id={this.state.itemSelected}
                    listGroupUser = {this.state.listGroupUser}
                />
                <ModalDeleteAdmissionsGroupUser
                    show={this.state.showModalDelete}
                    onHide={() => this.setState({showModalDelete: false})}
                    onRefresh={() => this.getListGroupCustomer()}
                    id={this.state.itemSelected}
                />
            </div>
        );
    }
}
export default AdmissionsGroupUserManagement;
